import { useFormHook, useSetError } from '@Hooks/index';
import { useCallback } from 'react';
import { createSchema } from '../businessAddressForm/businessAddressSchema';
import { useUpdateBusinessAddress } from '@Hooks/api/useUpdateBusinessAddress';
import { useNavigationManager } from '@Router/useNavigationManager';
import { useBoundStore } from '@Store/index';
import { OnboardingFormFields } from '@Types/index';
import { useSyncBusinessAddressSlice } from '@Hooks/useSyncBusinessAddressSlice';
import { getInitialState } from '@Components/inputs/AddressStateDropDown';

export const useBusinessAddressLogic = () => {
  const {
    customerData: { businessAddressData },
  } = useBoundStore((state) => state.customer);

  const { line1, line2, postalCode, state, city, sameAsPrimary } = businessAddressData;
  const defaultValues = {
    [OnboardingFormFields.LINE1]: line1 ?? '',
    [OnboardingFormFields.APARTMENT]: line2 ?? '',
    [OnboardingFormFields.CITY]: city ?? '',
    [OnboardingFormFields.STATE]: getInitialState(state) ?? '',
    [OnboardingFormFields.ZIP]: postalCode ?? '',
    [OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY]: sameAsPrimary ?? false,
  };
  const BusinessAddressSchema = createSchema();
  const { navigateToNextPage } = useNavigationManager();

  const formMethods = useFormHook({
    formSchema: BusinessAddressSchema,
    formDefaultValues: defaultValues,
    schemaTitle: 'businessAddressSchema',
    mode: 'onTouched',
  });

  const { syncBusinessAddress } = useSyncBusinessAddressSlice();
  const { mutateAsync: asyncUpdateBusiness, isPending } = useUpdateBusinessAddress((_, input) => {
    syncBusinessAddress(input);
    navigateToNextPage();
  });

  const handleSubmit = useCallback(async () => {
    const formData = formMethods.getValues();
    asyncUpdateBusiness(formData);
  }, [formMethods, asyncUpdateBusiness]);

  useSetError({ formMethods });

  return { handleSubmit, formMethods, isPending, defaultValues };
};
